import {
  InputGroup, InputRow, ModelInput, RadioYesNoInput,
} from '@equifinance/shared';
import { useCompanyContext } from '../../../../../contexts/company';
import { BrokerDetailGenericSection } from '../../../components/BrokerDetailGenericSection';

export const notificationsRefName = 'notifications-section';

export default function NotificationsSection() {
  const { company: { notifications } } = useCompanyContext();

  return (
    <BrokerDetailGenericSection
      id={notificationsRefName}
      refName={notificationsRefName}
      title="Notifications"
      level={1}
    >
      <InputGroup>
        <InputRow>
          <RadioYesNoInput
            label="Notifications to be sent to case owner?"
            field="notifications.emailCaseOwner"
            required
          />
        </InputRow>

        {notifications?.additionalEmailAddresses?.map((_, i) => (
          <InputRow>
            <ModelInput
              label={i === 0 ? 'Additional email address(es) for Notifications' : ''}
              field={`notifications.additionalEmailAddresses[${i}]`}
              required
            />
          </InputRow>
        ))}

      </InputGroup>
    </BrokerDetailGenericSection>
  );
}
